import React from "react";
import "./Style.css";
import { Spinner } from "react-bootstrap";

function Loading({}) {
  return (
    <div className='loading'>
      <Spinner className='loading-spinner' animation='border' />
    </div>
  );
}

export default Loading;
